"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PGxReasonForTestingDtoPrimaryReasonEnum = exports.PGxReasonForTestingDtoKidneyOrLiverProblemEnum = void 0;
exports.PGxReasonForTestingDtoKidneyOrLiverProblemEnum = {
    Eclampsia: 'eclampsia',
    HivInfection: 'HIV_infection',
    KidneyDialysis: 'kidney_dialysis',
    KidneyStone: 'kidney_stone',
    LiverCirrhosis: 'liver_cirrhosis',
    LupusNephritis: 'lupus_nephritis',
    PolycysticKidneys: 'polycystic_kidneys',
    RecentKidneyFailure: 'recent_kidney_failure',
    RecentKidneyInfection: 'recent_kidney_infection'
};
exports.PGxReasonForTestingDtoPrimaryReasonEnum = {
    AdverseDrugReaction: 'adverse_drug_reaction',
    IneffectiveMedication: 'ineffective_medication',
    InterestedInDna: 'interested_in_dna',
    InterestedInGenesMedication: 'interested_in_genes_medication',
    ProviderRecommended: 'provider_recommended'
};
